import React from 'react';
import PropTypes from 'prop-types';

import { Input } from 'semantic-ui-react';
import CommonErrorIcon
  from 'components/common/CommonErrorIcon';

import fieldDecorator from 'components/dashboard/signup-generator-content/SignupGeneratorAppearence/fieldDecorator';

import './SignupGeneratorField.css';

const SignupGeneratorField = (props) => {
  const { error = null, placeholder, fieldLabel, successUpdatedField } = props;
  const successObj = successUpdatedField && Object.keys(successUpdatedField).length > 0 ? successUpdatedField : null;
  const handleSuccess = successObj && successObj.name === props.name && successObj.success ? true : false;

  return (
    <div className={`email-signup-appearence-input__component ${error ? 'error': ''}`}>
      <div className={`email-signup-appearence-input-wrapper ${handleSuccess ? 'pulse' : ''}`}>
        <Input
          {...props}
          label={
            <div className="email-signup-appearence-input-placeholder">
              <span>{fieldLabel || placeholder}</span>
            </div>
          }
          labelPosition='right' // this item is required!
          data-empty={Boolean(!props.value)}
        />
      </div>

      {error &&
        <CommonErrorIcon
          key={`email-signup_appearence_input_${error.id}`}
          errorId={`email-signup_appearence_input_error_${error.id}`}
          errorText={error.text}
        />
      }
    </div>
  );
};

SignupGeneratorField.propTypes = {
  error: PropTypes.object,
  placeholder: PropTypes.string,
  fieldLabel: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  successUpdatedField: PropTypes.object,
};
SignupGeneratorField.defaultProps = {
  error: null,
  placeholder: null,
  fieldLabel: null,
  value: null,
  name: null,
  successUpdatedField: {},
};

export default fieldDecorator(SignupGeneratorField);
